module.exports = __webpack_public_path__ + "static/como-tornar-estudos-produtivos-071285b191737e51bad1f720df7cb1d8.jpg";